import type { CountdownUnit } from './types'

export const COUNTDOWN_UNITS: CountdownUnit[] = ['second', 'minute', 'hour', 'day']

export const CAMPAIGN_START_DATE_ISO = '2026-05-31T09:00:00+03:30'
export const CAMPAIGN_END_DATE_ISO = '2026-06-06T09:00:00+03:30'
export const START_TIME = new Date(CAMPAIGN_START_DATE_ISO).getTime()
export const END_TIME = new Date(CAMPAIGN_END_DATE_ISO).getTime()

export const PROGRESS_SEGMENT_COUNT = 20
export const INNER_TICK_COUNT = 30
export const MS_IN_SECOND = 1_000
export const MS_IN_MINUTE = MS_IN_SECOND * 60
export const MS_IN_HOUR = MS_IN_MINUTE * 60
export const MS_IN_DAY = MS_IN_HOUR * 24

export const ACTIVE_SEGMENT_COLOR = '#DB2777'
export const INACTIVE_SEGMENT_COLOR = '#E3D5F6'
